module.exports = __webpack_public_path__ + "assets/ce484d288e24099e623a14ff8d46c341.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/Waiting.mp3
 ** module id = 244
 ** module chunks = 0
 **/